import { Link } from "react-router-dom";
import "./Home.css";
import { Helmet } from "react-helmet";
import Carousel from "../components/Carousel";
import pizza1 from "../assets/images/pizza1.png";
import pizza2 from "../assets/images/pizza2.png";
import pizza3 from "../assets/images/pizza3.png";
import pizza4 from "../assets/images/pizza4.png";
import pizza5 from "../assets/images/pizza5.png";

const images = [pizza1, pizza2, pizza3, pizza4, pizza5];

const captions = [
  {
    subtitle: "La pizza è un atto d'amore",
  },
  {
    subtitle: "Ogni fetta è un sorriso",
  },
  {
    subtitle: "Se hai un problema, mangia una pizza",
  },
  {
    subtitle: "A Napoli, la pizza è una religione",
  },
  {
    subtitle: "La pizza è vita",
  },
];

const Home = () => {
  return (
    <>
      <Helmet>
        {/* Basisinformationen */}
        <title>Pizzeria 480 Grad – Neapolitanische Pizza in Nürnberg</title>
        <meta
          name="description"
          content="Original neapolitanische Pizza in Nürnberg – vegan, vegetarisch Jetzt online entdecken & genießen!"
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://www.480gradpizza.de/" />

        {/* Open Graph (Facebook, WhatsApp, LinkedIn) */}
        <meta
          property="og:title"
          content="Pizzeria 480 Grad – Neapolitanische Pizza in Nürnberg"
        />
        <meta
          property="og:description"
          content="Entdecke unsere authentische neapolitanische Pizza, kreative Drinks und mehr – mitten in Nürnberg."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.480gradpizza.de/" />
        <meta
          property="og:image"
          content="https://www.480gradpizza.de/pizza4.png"
        />
        <meta property="og:site_name" content="Pizzeria 480 Grad" />

        {/* Twitter Cards */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Pizzeria 480 Grad – Pizza in Nürnberg"
        />
        <meta
          name="twitter:description"
          content="Hausgemachte neapolitanische Pizza mit hochwertigen Zutaten – jetzt entdecken!"
        />
        <meta
          name="twitter:image"
          content="https://www.480gradpizza.de/pizza4.png"
        />

        {/* Lokales SEO */}
        <meta name="geo.region" content="DE-BY" />
        <meta name="geo.placename" content="Nürnberg" />
        <meta name="geo.position" content="49.451699;11.069709" />
        <meta name="ICBM" content="49.451699, 11.069709" />
      </Helmet>
      <div className="home">
        <Carousel images={images} captions={captions} interval={8000} />
        <div className="hero">
          <div className="buttons">
             <Link to="/menu" className="hero-btn">
            Speisekarte ansehen
          </Link>


          <br />
            <Link to="/contact" className="hero-btn">
              Kontakt / Reservieren
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
